import Schema from "AppReact/schema";
import { group, property } from "./types";

export default {
  left: Schema("integer", "primitive", { defaultValue: 0 }),
  properties: Schema(property, 'array', { defaultValue: [] }),
  groups: Schema(group, 'array', { defaultValue: [] }),
  selectedPropertyIds: Schema('integer', 'array', { defaultValue: [] }),
  selectedGroupIds: Schema('integer', 'array', { defaultValue: [] }),
  searchTerm: Schema("string", "primitive", { defaultValue: '' }),
  label: Schema("string", "primitive", { defaultValue: '' }),
  isOpen: Schema("boolean", "primitive", { defaultValue: false }),
  isReadonly: Schema("boolean", "primitive", { defaultValue: false }),
  fullWidth: Schema("boolean", "primitive", { defaultValue: false }),
  silentUpdate: Schema("boolean", "primitive", { defaultValue: false }),
};
